import { useNavigate } from "react-router-dom";
import Slider from "react-slick";

const CategoryBannerSlider = ({ categories }) => {
    const navigate = useNavigate();

    const settings = {
        dots: false,
        infinite: true,
        speed: 800,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        adaptiveHeight: true,
    };

    return (
        <div className="w-full mb-6">
            <div className="relative overflow-hidden">
                {/* Background Image */}
                <Slider {...settings}>
                    {categories?.map((category) => (
                        <div
                            key={category.id}
                            className="w-full h-32 sm:h-48 md:h-64 lg:h-74 bg-cover bg-center cursor-pointer bg-neutral-100"
                            onClick={() => {
                                if (category?.banner) {
                                    navigate(
                                        `/category/${category.name}/banner/${category?.banner?.vendors?.length > 0
                                            ? "vendors/products"
                                            : "products"
                                        }`
                                    );
                                }
                            }}
                            style={{
                                backgroundImage: `url(${category?.banner?.imageUrl ||
                                    "https://images.unsplash.com/photo-1606107557195-0e29a4b5b4aa?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80"
                                    })`,
                            }}
                        ></div>
                    ))}
                </Slider>

            </div>
        </div>
    );
};

export default CategoryBannerSlider;
